import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';

interface ICreatePasswordProps {
    email: string;
}

const resetPassword = async (
    email: ICreatePasswordProps
): Promise<Response> => {
    const response = await apiClient.post('users/reset-password', {
        json: email,
    });
    return response;
};

export const useResetPasswordMutation = (
    options: UseMutationOptions<
        Response,
        IRequestException,
        ICreatePasswordProps
    >
) => {
    return useMutation(async (email) => await resetPassword(email), options);
};
